/** A brand the guide can show, as its pill names it. */
export type BrandGuidePick = {
  key: string
  name: string
  /** Square mark, drawn in the pill. */
  markUrl: string
  /**
   * The mark is an icon on its own ground (an app tile, a filled circle):
   * it fills the pill's round chip, so the chip clips it to a clean circle,
   * instead of sitting inside it as a smaller square.
   */
  markFills?: boolean
}

/**
 * The brand guide's six brands, in pill order: Brew, then the five whose
 * production brand data the visual bundles (`brand-guide-brands.ts`, in the
 * visual's lazy chunk). Only what the pills draw, so the page itself
 * carries a few hundred bytes.
 */
export const BRAND_GUIDE_PICKS: ReadonlyArray<BrandGuidePick> = [
  {
    key: 'brew',
    name: 'Brew',
    markUrl: '/landing/home/brew-mark.webp',
    markFills: true,
  },
  {
    key: 'liveflow',
    name: 'LiveFlow',
    markUrl:
      'https://cdn.brew.new/brand-logos/w17bjqhy39c6vvzy1psfd5d5r988qpy1/logo-1784846596133.png',
  },
  {
    key: 'cursor',
    name: 'Cursor',
    markUrl:
      'https://cdn.brew.new/brand/w17b6ynbeez5ynd9hdaz7bvmvs8e1637/logo-1-07fe538c.png',
    markFills: true,
  },
  {
    key: 'clay',
    name: 'Clay',
    markUrl:
      'https://cdn.brew.new/brand/w17edze6vb9dfgpgbr0bxgb53n89mdae/logo-1-53ea6b67.jpeg',
    markFills: true,
  },
  {
    key: 'claude',
    name: 'Claude',
    markUrl:
      'https://cdn.brew.new/brand/w175z2xq1mrhwz96541mt6qfy18948q7/logo-4.png',
  },
  {
    key: 'ramp',
    name: 'Ramp',
    markUrl:
      'https://cdn.brew.new/brand/w172taswy22p4qd6c8hf1zy4pd89pwd2/logo-0.jpeg',
    markFills: true,
  },
]
